import React, { useState, useEffect, useRef } from 'react'
import { useAudio } from '../../contexts/AudioContext'
import './GameSettings.css'

const GameSettings = () => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)
  const { isSquareSpawnEnabled, toggleSquareSpawnSound } = useAudio()
  const [showAnnotations, setShowAnnotations] = useState(() => {
    const stored = localStorage.getItem('showSquareAnnotations')
    return stored !== null ? JSON.parse(stored) : false
  })

  const toggleAnnotations = () => {
    const newValue = !showAnnotations
    setShowAnnotations(newValue)
    localStorage.setItem('showSquareAnnotations', JSON.stringify(newValue))
    // Dispatch a custom event to notify other components
    window.dispatchEvent(new Event('annotationsChanged'))
  }

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }
  }, [isOpen])

  return (
    <div className="game-settings">
      <button
        className="settings-button"
        onClick={() => setIsOpen(!isOpen)}
        title="Game Settings"
      >
        ⚙️
      </button>
      {isOpen && (
        <div className="settings-dropdown" ref={dropdownRef}>
          <div className="setting-item">
            <label>
              <input
                type="checkbox"
                checked={isSquareSpawnEnabled}
                onChange={toggleSquareSpawnSound}
              />
              Special squares sound
            </label>
          </div>
          <div className="setting-item">
            <label>
              <input
                type="checkbox"
                checked={showAnnotations}
                onChange={toggleAnnotations}
              />
              Square annotations (a1, b2, etc.)
            </label>
          </div>
        </div>
      )}
    </div>
  )
}

export default GameSettings